export var gridContainerStyles={height:"100vh",alignItems:"center"};